export default { 
	name: "",
	description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis eu quam malesuada, porttitor ipsum in, commodo metus. Morbi cursus velit nec nibh hendrerit venenatis", 
	cover: "",
	metadata: [ { name: "", value: "" } ],
	product: { name: "", linkRewrite: "" }
}
